import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";
import PageLoading from "./common/pageLoading";

class DataUsage extends Component {
  state = {
    loading: "",
    stats: [],
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  async componentDidMount() {
    const stats = [
      { _id: 3, period: "Point of Presence", upload: "3" },
      { _id: 4, period: "Connected Subscribers", upload: "981" },
      { _id: 5, period: "Total Active Subscribers", upload: "804" },
      { _id: 1, period: "Active Subscribers (Corporate)", upload: "85" },
      { _id: 2, period: "Active Subscribers (Retail)", upload: "719" },
      { _id: 3, period: "Active Subscribers (Prepaid)", upload: "804" },
      { _id: 4, period: "Active Subscribers (Postpaid)", upload: "0" },
      {
        _id: 5,
        period: "Total Data Usage (Upload & Download)",
        upload: "992.4 TB",
      },
    ];

    this.setState({ stats, loading: false });
  }

  render() {
    const { stats1, stats, stats2, stats3, loading } = this.state;

    return (
      <React.Fragment>
        <Paper elevation={3}>
          <div className="card">
            <div className="card-header main-color-bg">
              <div>
                <h5>NCC Report</h5>
              </div>
            </div>
            <div className="card-body">
              <span className="card-text">
                {loading && <PageLoading loading={loading} />}
                {!loading && stats.length === 0 && (
                  <span>No Data Usage Statictics to Display</span>
                )}
                {!loading && stats.length > 0 && (
                  <TableContainer component={Paper}>
                    <Table className="mb-5" aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Q1 2024</StyledTableCell>
                          <StyledTableCell></StyledTableCell>
                          <StyledTableCell></StyledTableCell>
                          <StyledTableCell></StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {stats.map((stat) => (
                          <StyledTableRow key={stat._id}>
                            <StyledTableCell>{stat.period}</StyledTableCell>
                            <StyledTableCell>{stat.upload}</StyledTableCell>
                            <StyledTableCell>{stat.download}</StyledTableCell>
                            <StyledTableCell>
                              {stat.activeUsers}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </span>
            </div>
          </div>
        </Paper>
      </React.Fragment>
    );
  }
}

export default DataUsage;
